import { FetchAuth } from "../utils/FetchAuthUtil";
import { contactDetailsDTO, socialsDTO, WebSettingsDTO } from "../dto/WebSettingsDTO";
import { WebSettings, WebSettingsResponse } from "../types/WebSettings";

const endpoint = process.env.REACT_APP_API_ENDPOINT;

export class WebSettingsService {
    public static getWebSettings = async (): Promise<WebSettingsResponse> => {
        try {
            const response = await FetchAuth(`${endpoint}/websettings/get`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const data: WebSettingsResponse = await response.json();
            
            return {
                webSettings: {
                    description: {
                        title: {
                            eng: data.webSettings.description?.title?.eng || '',
                            fr: data.webSettings.description?.title?.fr || '',
                            ar: data.webSettings.description?.title?.ar || ''
                        },
                        body: {
                            eng: data.webSettings.description?.body?.eng || '',
                            fr: data.webSettings.description?.body?.fr || '',
                            ar: data.webSettings.description?.body?.ar || ''
                        }
                    },
                    helpAndSupport: {
                        eng: data.webSettings.helpAndSupport?.eng || '',
                        fr: data.webSettings.helpAndSupport?.fr || '',
                        ar: data.webSettings.helpAndSupport?.ar || ''
                    },
                    privacyPolicy: {
                        eng: data.webSettings.privacyPolicy?.eng || '',
                        fr: data.webSettings.privacyPolicy?.fr || '',
                        ar: data.webSettings.privacyPolicy?.ar || ''
                    },
                    termsAndConditions: {
                        eng: data.webSettings.termsAndConditions?.eng || '',
                        fr: data.webSettings.termsAndConditions?.fr || '',
                        ar: data.webSettings.termsAndConditions?.ar || ''
                    },
                    contactDetails: {
                        email: data.webSettings.contactDetails?.email || '',
                        phone: data.webSettings.contactDetails?.phone || '',
                        location: data.webSettings.contactDetails?.location || ''
                    },
                    socials: {
                        instagramUrl: data.webSettings.socials?.instagramUrl || '',
                        facebookUrl: data.webSettings.socials?.facebookUrl || '',
                        youtubeUrl: data.webSettings.socials?.youtubeUrl || '',
                        whatsappUrl: data.webSettings.socials?.whatsappUrl || '',
                        XUrl: data.webSettings.socials?.XUrl || ''
                    },
                    topPurchasedBookSection: data.webSettings.topPurchasedBookSection || false,
                    _id: data.webSettings._id || ''
                },
                publishedBooksCount: data.publishedBooksCount || 0
            };
        } catch (error) {
            console.error('Error fetching web settings:', error);
            return {
                webSettings: {
                    description: {
                        title: { eng: '', fr: '', ar: '' },
                        body: { eng: '', fr: '', ar: '' }
                    },
                    helpAndSupport: { eng: '', fr: '', ar: '' },
                    privacyPolicy: { eng: '', fr: '', ar: '' },
                    termsAndConditions: { eng: '', fr: '', ar: '' },
                    contactDetails: {
                        email: '',
                        phone: '',
                        location: ''
                    },
                    socials: {
                        instagramUrl: '',
                        facebookUrl: '',
                        youtubeUrl: '',
                        whatsappUrl: '',
                        XUrl: ''
                    },
                    topPurchasedBookSection: false,
                    _id: ''
                },
                publishedBooksCount: 0
            };
        }
    }

    public static updateContactDetails = async (contactDetails: contactDetailsDTO, _id: string): Promise<any> => {
        try {
            const resp = await FetchAuth(endpoint + `/websettings/update/${_id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    contactDetails
                }),
            });

            const data = await resp.json();
            return data;
        } catch (error) {
            throw error;
        }
    }

    public static updateSocials = async (socials: socialsDTO, _id: string): Promise<any> => {
        try {
            const resp = await FetchAuth(endpoint + `/websettings/update/${_id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ 
                    socials
                }),
            });

            const data = await resp.json();
            return data;
        } catch (error) {
            throw error;
        }
    }

    public static updateTopPurchasedBooks = async (enabled: boolean, _id: string): Promise<any> => {
        try {
            const resp = await FetchAuth(endpoint + `/websettings/update/${_id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ 
                    topPurchasedBookSection: enabled
                }),
            });

            const data = await resp.json();
            return data;
        } catch (error) {
            throw error;
        }
    }

    static async updateWebSettings(settings: WebSettings, _id: string): Promise<void> {
        try {
            await FetchAuth(endpoint + `/websettings/update/${_id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    description: {
                        title: settings.description.title,
                        body: settings.description.body
                    },
                    helpAndSupport: settings.helpAndSupport,
                    privacyPolicy: settings.privacyPolicy,
                    termsAndConditions: settings.termsAndConditions,
                    contactDetails: settings.contactDetails,
                    socials: settings.socials,
                    topPurchasedBookSection: settings.topPurchasedBookSection
                }),
            });
        } catch (error) {
            console.error('Error updating web settings:', error);
            throw error;
        }
    }
} 